// const api =
//   process.env.NODE_ENV === "production"
//     ? "https://api.huestimates.com/app/teach/controller"
//     : "http://localhost:7710/controller";
const api = "https://teach.huestimates.app/api/controller";

const uploadUrl = "https://teach.hu-st.com/upload.php";
const fileUrl = "https://teach.hu-st.com/";
const nophoto = "https://teach.hu-st.com/default.png";

// const uploadUrl = "https://api.huestimates.com/app/teach/controller/upload.php";
// const fileUrl = "https://api.huestimates.com/uploads/teach/";
// const nophoto = "https://api.huestimates.com/uploads/teach/default.png";
function ShowLink(value) {
  if (!value) return;
  var text = value;
  var exp = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
  var text1 = text.replace(exp, "<a href='$1'>$1</a>");
  var exp2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
  return text1.replace(exp2, '$1<a target="_blank" href="http://$2">$2</a>');
}

function HtmlNewLine(value) {
  if (!value) return;
  return value.replace(/(?:\r\n|\r|\n)/g, "<br />");
}

function DateToString(dt) {
  dt = new Date(dt);
  let date = ("0" + dt.getDate()).slice(-2);

  let month = ("0" + (dt.getMonth() + 1)).slice(-2);

  let year = dt.getFullYear();

  return year + "-" + month + "-" + date;
}

function DateTimeToString(dt) {
  dt = new Date(dt);
  let date = ("0" + dt.getDate()).slice(-2);

  let month = ("0" + (dt.getMonth() + 1)).slice(-2);

  let year = dt.getFullYear();

  let hour = dt
    .getHours()
    .toString()
    .padStart(2, "0");

  let minutes = dt
    .getMinutes()
    .toString()
    .padStart(2, "0");

  let seconds = dt
    .getSeconds()
    .toString()
    .padStart(2, "0");

  return (
    year + "-" + month + "-" + date + " " + hour + ":" + minutes + ":" + seconds
  );
}

export {
  ShowLink,
  HtmlNewLine,
  uploadUrl,
  fileUrl,
  api,
  nophoto,
  DateToString,
  DateTimeToString
};
